import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import { PrismicLink, PrismicRichText } from '@prismicio/react'

const BannerWithCaption = ({ slice }) => {
  var position = 'left'
  if (slice.primary.image_position === true) {
    position = 'right'
  }
  return (
    <section className={`component-${slice.slice_type} relative ${position} container max-w-screen-xl mx-auto my-5`}>
      {slice.primary.image.gatsbyImageData && (
        <div className={`h-56 sm:h-72 relative md:absolute ${position}-0 md:h-full md:w-1/2`}>
          <GatsbyImage image={slice.primary.image.gatsbyImageData} className='w-full h-full object-cover overflow-hidden rounded-sm' alt={slice.primary.image.alt || ''} />
          {slice.primary.image.copyright && <span className='absolute bottom-0 right-0 text-white bg-black opacity-50 m-2 px-2 py-1 text-xs rounded-sm'>{slice.primary.image.copyright}</span>}
        </div>
      )}
      <div className='relative max-w-7xl mx-auto -mt-5 md:mt-0 md:py-12 lg:py-16'>
        <div
          className={`${
            position === 'left' ? 'md:ml-auto md:mr-0 md:-left-10' : 'md:mr-auto md:ml-0 md:-right-10'
          } mx-3 md:w-1/2 px-8 py-10 space-y-6 relative rounded-bl-none rounded-xl shadow-lg text-white bg-gradient-to-tr from-indigo-700 to-indigo-800 border-2 border-indigo-600 shadow-indigo-500/50 dark:shadow-indigo-700/50`}>
          {slice.primary.intro && (
            <span
              id={slice.primary.intro.split(' ').join('-').toLowerCase()}
              className='inline-block leading-6 tracking-wider py-0.5 px-1.5 rounded-sm self-start uppercase bg-indigo-600 text-purple-50'>
              {slice.primary.intro}
            </span>
          )}
          {slice.primary.title.text && <h2 id={slice.primary.title.text.split(' ').join('-').toLowerCase()}>{slice.primary.title.text}</h2>}
          {slice.primary.text.html && (
            <div className='prose prose-lg prose-invert'>
              <PrismicRichText field={slice.primary.text.richText} />
            </div>
          )}
          {slice.primary.button_link && (
            <PrismicLink className='button hover:bg-indigo-600 inline-block' field={slice.primary.button_link}>
              {slice.primary.button_text}
            </PrismicLink>
          )}
        </div>
      </div>
    </section>
  )
}

export default BannerWithCaption
